// src/components/CriticalPathHorizontal/CpChatDot.js
import React from "react";
import { Box, Tooltip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useTranslation } from "react-i18next";

export default function CpChatDot({
  noLeidos = 0,
  hasMessages = false,
  hasMention = false,
  size = 28,
  onClick,
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const iconSize = Math.max(12, Math.round(size * 0.5));

  return (
    <Tooltip
      title={
        hasMention
          ? t("Samples.chatMention", { defaultValue: "You were mentioned" })
          : noLeidos > 0
            ? `${noLeidos} unread`
            : hasMessages
              ? "Chat"
              : t("Samples.chat", { defaultValue: "Chat" })
      }
    >
      <Box
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onClick?.(e);
        }}
        sx={{
          width: size,
          height: size,
          minWidth: size,
          minHeight: size,
          flexShrink: 0,
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontSize: size <= 22 ? "0.62rem" : "0.7rem",
          fontWeight: 800,
          lineHeight: 1,
          color: "#fff",
          bgcolor: hasMention
            ? "warning.main"
            : noLeidos > 0
              ? "error.main"
              : hasMessages
                ? "info.main"
                : alpha(theme.palette.text.secondary, 0.35),
          boxShadow: hasMention ? "0 0 0 2px rgba(237,108,2,0.35)" : "none",
          "&:hover": { opacity: 0.9 },
        }}
      >
        {noLeidos > 0 ? (
          noLeidos
        ) : (
          <ChatBubbleOutlineIcon sx={{ fontSize: iconSize }} />
        )}
      </Box>
    </Tooltip>
  );
}
